import { PlaceholdersId, TFComponent } from '@types';
import { PromotionalCodePlaceholder } from './promotionalCode';

export const promotionalCode: TFComponent = {
	component: PromotionalCodePlaceholder,
	id: PlaceholdersId.promotionalCode,
	name: 'promotionalCode',
};
